import { getSessionStorage } from './storage/sessionStorage';

const key = 'PUBLIC_TOKEN';

export const setPublicToken = token => getSessionStorage().setItem(key, token);
export const getPublicToken = () => getSessionStorage().getItem(key);
export const removePublicToken = () => getSessionStorage().removeItem(key);
